import { OverlaysState } from 'data/overlays/interfaces';

interface IStoreWithOverlays {
    overlaysReducer: OverlaysState;
}
export const overlaysSelector = (store: IStoreWithOverlays) => {
    return store.overlaysReducer;
};
